module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/235.a3d81d25.png";